import React, { useEffect, useState, useContext, useRef } from "react";
import { api_call } from "../../utils/Network";

import styles from "./About.module.css";
import mainImg from "../../assets/aboutMain.png";
import smallRect from "../../assets/Rectangle.png";
import smallCircle from "../../assets/Ellipse 15.png";
import mediumCircle from "../../assets/Ellipse 13.png";
import extSmallCircle from "../../assets/Ellipse 9.png";
import Grf from "../../assets/GRF_TM.png";
import { MainContext } from "../../utils/context";
import {
  appendImageUrl,
  getSavedData,
  isMobiledevice,
  saveLocalData,
} from "../../utils/helperFunctions";

const isSafari = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf("safari") > -1 && ua.indexOf("chrome") < 0;
};

function About() {
  const { setCurrentPath } = useContext(MainContext);
  const [data, setData] = useState([]);
  // const [test, setTest] = useState([]);
  const [banner, setBanner] = useState("");
  const [team, setTeam] = useState([]);
  const [shouldUseImage, setShouldUseImage] = useState(false);
  const videoParentRef = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
    setCurrentPath(window.location.href.split("/")[4]);
    if (getSavedData("aboutData")) setData(getSavedData("aboutData"));
    if (getSavedData("homeBanner")) setBanner(getSavedData("homeBanner"));
    if (getSavedData("teamData")) setTeam(getSavedData("teamData"));
    // getBanner();
    getTeam();
    // getTest();
  }, []);

  useEffect(() => {
    if (isSafari() && videoParentRef.current) {
      const player = videoParentRef.current.children[0];
      if (player) {
        player.controls = false;
        player.playsinline = true;
        player.muted = true;
        player.setAttribute("muted", "");
        player.autoplay = true;
        setTimeout(() => {
          const promise = player.play();
          if (promise.then) {
            promise
              .then(() => {})
              .catch(() => {
                videoParentRef.current.style.display = "none";
                setShouldUseImage(true);
              });
          }
        }, 0);
      }
    }
  }, []);

  const getBanner = () => {
    api_call
      .get(`/service_list/info/about/banner/`)
      .then((response) => {
        saveLocalData("aboutBanner", data.banner1);
        setBanner(data.banner1);
      })
      .catch((error) => {
        console.log(error.response, "Error occured");
      });
  };

  const getTeam = () => {
    api_call
      .get(`/service_list/info/about_us/`)
      .then((response) => {
        const resData = response.data;
        setTeam(resData.data);
        setData(resData.data2);
        saveLocalData("teamData", resData.data);
        saveLocalData("aboutData", resData.data2);
      })
      .catch((error) => {
        console.log(error.response, "Error occured");
      });
  };

  const getTest = () => {
    api_call
      .post(`auth/ratings/view_review/`, {}) // Empty payload i.e body for testimonials
      .then((response) => {
        const data = response.data.data;
        // setTest(data);
        saveLocalData("testData", data);
      })
      .catch((error) => {
        console.log(error.response, "Error occured");
      });
  };

  return (
    <div>
      <div className={styles.banner}>
        {shouldUseImage ? (
          <img className={styles.bannerVideo} src={banner} alt="Muted Video" />
        ) : (
          <div
            className={styles.bannerVideo}
            ref={videoParentRef}
            dangerouslySetInnerHTML={{
              __html: `
                  <video class="${styles.bannerVideo}" loop muted autoplay playsinline preload="metadata">
                    <source src="${banner}" type="video/mp4" />
                  </video>`,
            }}
          />
        )}
      </div>
      {/* <div className={`${styles.min_width} ${styles.about_content}`}>
        <img src={video} alt="Background" className={styles.image}></img>
      </div> */}
      <div className={`${styles.min_width} ${styles.abt_detail}`}>
        <div className={styles.rectangle_box}>
          <img src={mainImg} alt="Rectangle" className={styles.mainImg} />
          <img
            src={smallCircle}
            alt="smallCircle"
            className={styles.smallCircle}
          />
        </div>
        <div className={styles.aboutUs}>
          <h3 style={{ color: "#4d3060" }} className={styles.mainText}>
            {data.length > 2 && data[1].title ? data[1].title : "About Us"}
          </h3>
          {data.length > 2 && data[1].point ? (
            <div
              className={styles.descriptions}
              dangerouslySetInnerHTML={{ __html: `${data[1].point}` }}
            ></div>
          ) : (
            <p className={styles.description}>
              An ISO 9001:2005 certified Premium Company that specialises in
              cleaning, hygiene, facility rejuvenation and staffing requirements
              for homes and businesses.
              <br />
              <br />
              Gaining over 5 years of experience in multiple service industries
              working with premium brands, the business is being managed by
              professionals from hospitality, facility management, staffing
              backgrounds and has diversified into Housekeeping, Facility
              Management, Horticulture, Pest Control, Staffing & Placement,
              Sanitization & Other Allied Services.
            </p>
          )}
          <div>
            <img src={smallRect} alt="small_rect"></img>
          </div>
        </div>
      </div>

      <div className={`${styles.min_width} ${styles.sets_upart}`}>
        <h3 className={styles.setApt}>
          What sets us <br />
          <span style={{ fontWeight: "bolder" }}>apart?</span>
        </h3>
        {data.length > 2 && data[2].point ? (
          <div className={styles.apt_container}>
            {data[2].point
              .split("</p>")
              .slice(0, 4)
              .map((val, i) => (
                <div className={styles.apt_block} key={i}>
                  <p dangerouslySetInnerHTML={{ __html: val }} className={styles.service_content}></p>
                </div>
              ))}
            <img
              src={mediumCircle}
              alt="mediumCircle"
              className={styles.medium}
            />
            <img src={smallCircle} alt="small" className={styles.sm_circle} />
            <img src={extSmallCircle} alt="small" className={styles.extSmall} />
          </div>
        ) : (
          ""
        )}
      </div>

      <div className={`${styles.min_width} ${styles.grf_mean}`}>
        <div className={styles.whatwedo}>
          <div className={styles.imgContain}>
          <img src={Grf} alt="grf" className={styles.imgGrf}></img>
          </div>
        </div>
        <div className={styles.whatwedo}>
          <div className={styles.textContainer}>
            <h3
              style={{
                color: "#4d3060",
                marginLeft: "auto",
                marginRight: "5%",
              }}
              className={styles.mainText}
            >
              {data.length > 0 && data[0].title
                ? data[0].title
                : "What does GRF mean?"}
            </h3>
            {data.length > 0 && data[0].point ? (
              <div className={styles.grf_details}>
                {data[0].point.split("</p>").map((val,i) => (
                  <p key={i} dangerouslySetInnerHTML={{ __html: val }}></p>
                ))}
              </div>
            ) : (
              <p className={styles.description}>
                <br />
                <span className={styles.grf_subt}>G - Governance</span>
                <br />
                Extemporize accountability with disciplined and transparent best
                practice.
                <br />
                <br />
                <span className={styles.grf_subt}>R – Resourcefulness</span>
                <br />
                Garner skill acumen competency to solution oriented proficiency.
                <br />
                <br />
                <span className={styles.grf_subt}>F - Faithfulness</span>
                <br />
                Inculcate integrity, warmth and pride in service with
                consistency. care and trust.
              </p>
            )}
          </div>
        </div>
      </div>

      <div className={`${styles.min_width} ${styles.team_container}`}>
        <div className={styles.team_inner}>
          <div className={styles.team}>
            <h3
              style={{ color: "white", textAlign: "center" }}
              className={styles.mainText}
            >
              Meet The Team
            </h3>
            <div
              style={{
                flexDirection: "column",
                alignItems: "center",
                marginTop: 15,
              }}
              className={styles.cardContainer}
            >
              {team.map(
                (content, i) =>
                  i < 2 && (
                    <div
                      style={isMobiledevice() ? {} : { width: 380 }}
                      key={i}
                      className={styles.card}
                    >
                      <div
                        style={{
                          backgroundImage: `url(${appendImageUrl(
                            content.image
                          )})`,
                          minHeight: isMobiledevice() ? 300 : 400,
                        }}
                        className={styles.personImage}
                      ></div>
                      <div className={styles.cardText}>
                        {content.member_name}
                        <br style={{ marginBottom: 5 }} />
                        {content.designation}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div style={{ marginBottom: 15 }} className={styles.cardContainer}>
              {team.map(
                (content, i) =>
                  i > 1 && (
                    <div key={i} className={styles.card}>
                      <div
                        style={{
                          backgroundImage: `url(${appendImageUrl(
                            content.image
                          )})`,
                        }}
                        className={styles.personImage}
                      ></div>
                      <div className={styles.cardText}>
                        {content.member_name}
                        <br style={{ marginBottom: 5 }} />
                        {content.designation}
                      </div>
                    </div>
                  )
              )}
            </div>
          </div>
        </div>
        <img
          src={mediumCircle}
          alt="medium"
          className={styles.meet_circle_large}
        ></img>
        <img
          src={smallCircle}
          alt="small"
          className={styles.meet_circle_small}
        ></img>
        <img
          src={extSmallCircle}
          alt="ext"
          className={styles.meet_circle_ext_small}
        ></img>
        <img
          src={extSmallCircle}
          alt="ext"
          className={styles.meet_circle_ext_sm}
        ></img>
      </div>
    </div>
  );
}

export default About;
